import { CustomTransactionItemValue } from '@/features/InvoiceReport/Edit/type';
import { toISODateString, toISODateStringYearMonth } from 'date-util';
import { Dayjs, isDayjs } from 'dayjs';

export const formatPulldownOptionForExport = (
  label?: CustomTransactionItemValue,
  code?: string
) => {
  return label === undefined
    ? ''
    : String(label).concat(code ? `(${code})` : '') ?? '';
};

export const formatDateForExport = (
  unformatted?: string | number | boolean | Dayjs | null | undefined,
  dateFormatType?: string
) => {
  if (isDayjs(unformatted) && dateFormatType === 'year_month') {
    return toISODateStringYearMonth(unformatted) || '';
  } else if (isDayjs(unformatted)) {
    return toISODateString(unformatted) || '';
  }

  return String(unformatted || '');
};
